import * as React from 'react';

export const UserDataContext = React.createContext<any>({
  userData: {},
  updateUserData: (userData: any) => {},
});
